<main class="main-dashboard">
  <article class="main-canvas">
    <section class="canvas-container">
      <section class="dashboard-items">
        <div class="canvas-item">
          <div class="canvas-header row justify-content-between align-items-center">
            <div class="title col-sm-6">
              <div class="d-flex align-items-center">
                <div class="edit">
                  <button (click)="backToMyProjectV2()">
                    <span><i class="ri-arrow-left-line"></i></span>
                  </button>
                </div>
                <h3 class="px-3">My Project-V2</h3>
              </div>
            </div>
          </div>
          <div class="canvas-header row justify-content-between align-items-center">
            <div class="title col-sm-6 d-flex">
              <h3><a class="active">Details</a></h3>
              <h3><a (click)="this.currentProjectId && openProjectTab('sub-project-v2')">Sub-Project</a></h3>
              <h3><a (click)="this.currentProjectId && openProjectTab('task-v2')">Tasks</a></h3>
              <h3><a (click)="this.currentProjectId && openProjectTab('resource-v2')">Resources</a></h3>
              <h3><a (click)="this.currentProjectId && openProjectTab('partlist')">Part List</a></h3>
            </div>
          </div>
          <div class="canvas-data">
            <form [formGroup]="projectv2Form">
              <div class="row">
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <select formControlName="regionName" (change)="getIndustryByRegion($event)">
                        <option value="" disabled>Select Region</option>
                        <option *ngFor="let region of regionDropdown" value="{{region}}">{{region}}</option>
                      </select>
                      <label class="floating-label-special">Region*</label>
                      <i class="ri-global-fill"></i>
                    </div>
                    <mat-error *ngIf="f.regionName.touched && f.regionName.invalid" class="alert alert-danger">
                      <mat-error *ngIf="f.regionName.errors.required"> Region is required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <select formControlName="industryName" (change)="getBusinessGroupByIndustry($event)">
                        <option value="" disabled>Select Industry</option>
                        <option *ngFor="let industry of industryDropdown" value="{{industry}}">{{industry}}</option>
                      </select>
                      <label class="floating-label-special">Industry*</label>
                      <i class="ri-organization-chart"></i>
                    </div>
                    <mat-error *ngIf="f.industryName.touched && f.industryName.invalid" class="alert alert-danger">
                      <mat-error *ngIf="f.industryName.errors.required"> Industry is required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <select formControlName="businessGroupName" (change)="getCommodityByBG($event)">
                        <option value="" disabled>Select Business Group</option>
                        <option *ngFor="let bg of businessGroupDropdown" value="{{bg}}">{{bg}}</option>
                      </select>
                      <label class="floating-label-special">Business Group*</label>
                      <i class="ri-verified-badge-fill"></i>
                    </div>
                    <mat-error *ngIf="f.businessGroupName.touched && f.businessGroupName.invalid" class="alert alert-danger">
                      <mat-error *ngIf="f.businessGroupName.errors.required"> Business is required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <select formControlName="commodityName">
                        <option value="" disabled>Select Commodity Name</option>
                        <option *ngFor="let commodity of commodityDropdown" value="{{commodity}}">{{commodity}}</option>
                      </select>
                      <label class="floating-label-special">Commodity Name*</label>
                      <i class="ri-archive-drawer-line"></i>
                    </div>
                    <mat-error *ngIf="f.commodityName.touched && f.commodityName.invalid" class="alert alert-danger">
                      <mat-error *ngIf="f.commodityName.errors.required"> Commodity is required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <select formControlName="activityName" (change)="getSoftwareByActivity($event)">
                        <option value="" disabled>Select Activity</option>
                        <option *ngFor="let activity of activityDropdown" value="{{activity}}">{{activity}}</option>
                      </select>
                      <label class="floating-label-special">Activity*</label>
                      <i class="ri-archive-drawer-line"></i>
                    </div>
                    <mat-error *ngIf="f.activityName.touched && f.activityName.invalid" class="alert alert-danger">
                      <mat-error *ngIf="f.activityName.errors.required"> Activity is required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <select formControlName="projectSoftwareName">
                        <option value="" disabled>Select Project Software</option>
                        <option *ngFor="let projectSoftware of projectSoftwareDropdown" value="{{projectSoftware}}">{{projectSoftware}}</option>
                      </select>
                      <label class="floating-label-special">Project Software Name*</label>
                      <i class="ri-archive-drawer-line"></i>
                    </div>
                    <mat-error *ngIf="f.projectSoftwareName.touched && f.projectSoftwareName.invalid" class="alert alert-danger">
                      <mat-error *ngIf="f.projectSoftwareName.errors.required"> Project Softwar is required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="projectName" />
                      <label class="floating-label floating-label-special">Project Name*</label>
                      <i class="ri-file-list-line"></i>
                    </div>
                    <mat-error *ngIf="f.projectName.touched && f.projectName.invalid" class="alert alert-danger">
                      <mat-error *ngIf="f.projectName.errors.required">Project Name is required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="projectCode" />
                      <label class="floating-label floating-label-special">Project Code*</label>
                      <i class="ri-hashtag"></i>
                    </div>
                    <mat-error *ngIf="f.projectCode.touched && f.projectCode.invalid" class="alert alert-danger">
                      <mat-error *ngIf="f.projectCode.errors.required">Project Code is required</mat-error>
                      <mat-error *ngIf="f.projectCode.errors.pattern">Project Code must contain numbers only</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input list="taskOwnerDatalist" placeholder="Select Project Manager" formControlName="projectManagerName" />
                      <label class="floating-label">Project Manager*</label>
                      <datalist id="taskOwnerDatalist">
                        <option [value]="item" *ngFor="let item of userDropdownList"></option>
                      </datalist>
                      <i class="ri-user-2-line"></i>
                    </div>
                    <mat-error *ngIf="f.projectManagerName.touched && f.projectManagerName.invalid" class="alert alert-danger">
                      <mat-error *ngIf="f.projectManagerName.errors.required">Project Manager is required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input list="taskOwnerDatalist" placeholder="Select Project Lead" formControlName="projectLeadName" />
                      <label class="floating-label">Project Lead*</label>
                      <datalist id="taskOwnerDatalist">
                        <option [value]="item" *ngFor="let item of userDropdownList"></option>
                      </datalist>
                      <i class="ri-user-2-line"></i>
                    </div>
                    <mat-error *ngIf="f.projectLeadName.touched && f.projectLeadName.invalid" class="alert alert-danger">
                      <mat-error *ngIf="f.projectLeadName.errors.required">Project Lead is required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="date" formControlName="startDate" />
                      <label class="floating-label floating-label-special">Start Date*</label>
                      <i class="ri-calendar-check-line"></i>
                    </div>
                    <mat-error *ngIf="f.startDate.touched && f.startDate.invalid" class="alert alert-danger">
                      <mat-error *ngIf="f.startDate.errors.required">Start Date is required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="date" formControlName="endDate" />
                      <label class="floating-label floating-label-special">End Date* </label>
                      <i class="ri-calendar-check-line"></i>
                    </div>
                    <mat-error *ngIf="f.endDate.touched && f.endDate.invalid" class="alert alert-danger">
                      <mat-error *ngIf="f.endDate.errors.required">End Date is required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="date" formControlName="decisionDate" />
                      <label class="floating-label floating-label-special">Decision Date</label>
                      <i class="ri-calendar-check-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <select formControlName="status">
                        <option value="" disabled selected>Select Status</option>
                        <option value="Active">Active</option>
                        <option value="On hold">On hold</option>
                        <option value="Archive">Archive</option>
                      </select>
                      <label for="status" class="floating-label floating-label-special">Project Status</label>
                      <i class="ri-inbox-archive-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" disabled="true" formControlName="createdByUserName" />
                      <label class="floating-label-special">Created By</label>
                      <i class="ri-user-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="customer"/>
                      <label class="floating-label floating-label-special">Customer*</label>
                      <i class="ri-user-line"></i>
                    </div>
                    <mat-error *ngIf="f.customer.touched && f.customer.invalid" class="alert alert-danger">
                      <mat-error *ngIf="f.customer.errors.required">Customer is required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="totalHours" />
                      <label class="floating-label floating-label-special">Total Hours</label>
                      <i class="ri-user-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="number" min="0" max="1000" step="1" disabled="true" formControlName="remainingHours" />
                      <label class="floating-label-special">Remaining Hours</label>
                      <i class="ri-time-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="percentageCompleted" disabled />
                      <label class="floating-label-special">% of Project Completion</label>
                      <i class="ri-progress-2-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <textarea name="" id="" cols="20" rows="4" formControlName="projectDescription"></textarea>
                      <label class="floating-label">Project description</label>
                      <i class="ri-file-list-3-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 mt-3 mb-2">
                  <div class="d-flex gap-2 justify-content-end">
                    <div *ngIf="this.isPMOAdmin"><a class="btn" (click)="updateorcreateParametersV2()"
                        [class.disabled]="!projectv2Form.valid ? true : null" *ngIf="this.currentProjectId">Update</a>
                    </div>
                    <a class="btn" (click)="updateorcreateParametersV2()"
                    [class.disabled]="!projectv2Form.valid ? true : null" *ngIf="!this.currentProjectId">Create</a>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </section>
  </article>
</main>